module.exports = __webpack_public_path__ + "/login_ui/img/lb-86431875ef2fd4b52cad3ff9c8957175.svg";